import { render, staticRenderFns } from "./RegistrosFundo.vue?vue&type=template&id=b10cd178&scoped=true&"
import script from "./RegistrosFundo.vue?vue&type=script&lang=js&"
export * from "./RegistrosFundo.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosFundo.vue?vue&type=style&index=0&id=b10cd178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10cd178",
  null
  
)

export default component.exports